import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { MultiplierRadioButtonCPanelComponent } from './customizationPanel';
import {
  DEFAULT_MULTIPLIER_OPTION_KEY,
  isDefaultMultiplierOption,
  MultiplierRadioButtonCustomization,
} from './multiplier-answer';

@Component({
  selector: 'lib-multiplier-radiobutton-edit',
  imports: [
    FormsModule,
    DecimalPipe,
    RadioButtonModule,
    InputNumberModule,
    MultiplierRadioButtonCPanelComponent,
  ],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-multiplier-radiobutton-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="relative flex h-full flex-col gap-2">
        @if (!widgetService.baseElementShowDescription()) {
          <div class="flex flex-row items-center gap-2">
            {{ widgetService.computedDescription() }}
          </div>
        }
        <div [class]="'p-fluid flex flex-wrap' + topologyStyle">
          @for (
            option of widget.customization.options;
            track option.key;
            let i = $index
          ) {
            <div class="flex flex-row items-center gap-2">
              <p-radioButton
                [autofocus]="false"
                [value]="option.key"
                [ngModel]="defaultKey"
                [disabled]="true"
                inputId="{{ widgetService.uniqueId }}-{{ i }}"
              ></p-radioButton>
              <label for="{{ widgetService.uniqueId }}-{{ i }}">
                {{ option.label }}
                @if (!isDefault(option)) {
                  (×{{ option.multiplier | number: '1.0-3' }}, max
                  {{
                    widgetService.getWeightedPoints(
                      option.multiplier * (option.max ?? 0)
                    )()
                  }}
                  pt)
                }
              </label>
            </div>
          }
        </div>
        <div class="p-fluid flex w-full flex-row">
          <p-inputNumber
            [autofocus]="false"
            [ngModel]="0"
            [disabled]="true"
            class="w-full rounded-md bg-white opacity-60"
            decrementButtonClass="bg-accent"
            incrementButtonClass="bg-accent"
          />
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class MultiplierRadioButtonComponent {
  public dragDropService = inject(DragDropService);
  protected widgetService = inject(
    WidgetService<MultiplierRadioButtonCustomization>,
  );

  protected readonly defaultKey = DEFAULT_MULTIPLIER_OPTION_KEY;
  protected readonly isDefault = isDefaultMultiplierOption;
  protected topologyStyle = ' flex-row gap-5';
}
